<template>
  <div class="brand">
    <header>
      <div class="title">品牌故事</div>
    </header>
    <div class="headerBlk"></div>
    <!-- <h1 class="animated fadeInRight infinite">Animate</h1> -->
    <div class="container">
      <div class="row">
        <ul class="voicelist">
          <li v-for="ls in articles" :key="ls.id" :id="'ls-'+ls.id">
            <router-link :to="'/brand/'+ls.id">
              <img :src="'@/../static/img/brand-'+ls.id+'-0.jpg'" alt="">
              <div class="name">{{ls.name}}</div>
            </router-link>
            <div v-if="ls.name === $store.state.player.voiceName" class="toplay nowplay" @click="pause()">
              <i :class="[ $store.state.player.playnow ? 'icon-pa' :'icon-player']"></i>
            </div>
            <div v-if="ls.name !== $store.state.player.voiceName" class="toplay" @click="playVoice(ls)">
              <i class="icon-player"></i>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="navsBlk"></div>

  </div>
</template>

<script>
import navs from '@/components/nav'
import { idNb, playUrls, imgUrl, voiceName } from 'vuex'
export default {
  name: 'brand',
  components: {
    navs
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      articles: '',
      paused: false
    }
  },
  created() {
    // this.$store.state.player.playerDisplay = true
    this.fetchArticles()
    this.$store.state.player.ize = false
    $(window).scrollTop(0)
  },
  methods: {
    fetchArticles: function() {
      axios.get('static/item.json').then(
        response => {
          this.articles = response.data.brand
        },
        error => {
          console.log(error)
        }
      )
    },
    playVoice(it) {
      this.$store.state.player.idNb = it.id
      this.$store.state.player.toUrl = '/brand/' + it.id
      this.$store.state.player.imgUrl = './static/img/brand-' + it.id + '-0.jpg'
      this.$store.state.player.voiceName = it.name
      this.$store.dispatch(
        'SET_PLAY_URL',
        './static/mp3/brand-' + it.id + '.mp3'
      )
      this.$store.dispatch(
        'SET_PLAY_URL_IOS',
        './static/mp3/brand-' + it.id + '.mp3'
      )
      // this.paused = this.$store.state.player.paused
      // this.$store.state.player.ize = true
      this.$store.state.player.prompts = false
    },
    pause() {
      this.$store.dispatch('SET_PAUSE')
      this.playnow = !this.playnow
    }
  },
  computed: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/ly.scss';
</style>



// WEBPACK FOOTER //
// src/pages/brand.vue